<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <div class="row">
            <CCol sm="6" class="align-self-center">
              <strong>Professionals</strong>
            </CCol>
            <CCol sm="6" class="align-self-center">
              <div class="text-sm-right mt-3 mt-sm-0">
                <CButtonGroup class="file-export">
                  <CButton color="secondary" disabled>
                    {{ $lang.buttons.export.title }}
                  </CButton>
                  <CButton color="danger" v-c-tooltip="$lang.buttons.export.pdf"
                    v-on:click="exports(self, 'pdf', module, 'DirectCandidates')">
                    <i class="fas fa-file-pdf"></i>
                  </CButton>
                  <VueJsonToCsv class="btn btn-success" v-c-tooltip="$lang.buttons.export.excel" :json-data="json_data"
                    :labels="json_label" :csv-title="json_title">
                    <i class="fas fa-file-excel"></i>
                  </VueJsonToCsv>
                </CButtonGroup>
                <BeforeFilter
                    :filterShow="toggleFilterValue"
                    @getFilterToggle="switchFilter"
                ></BeforeFilter>
              </div>
            </CCol>
          </div>
        </CCardHeader>
        <CCardBody>
          <transition name="fade">
            <CRow v-if="toggleFilterValue">
              <CCol sm="3">
                <div class="form-group">
                  <label class="form__label">{{
                      $lang.opportunity.filter.startDate
                    }}</label>
                  <input
                      type="date"
                      :placeholder="$lang.opportunity.filter.startDate"
                      class="form-control"
                      v-model="resource.startDate"
                  />
                </div>
              </CCol>
              <CCol sm="3">
                <div class="form-group">
                  <label class="form__label">{{
                      $lang.opportunity.filter.endDate
                    }}</label>
                  <input
                      type="date"
                      :placeholder="$lang.opportunity.filter.endDate"
                      class="form-control"
                      v-model="resource.endDate"
                  />
                </div>
              </CCol>
              <!-- <CCol sm="3">
                <div class="form-group">
                  <label class="form__label">Status</label>
                  <v-select
                      :options="statusOptions"
                      v-model="resource.status"
                  ></v-select>
                </div>
              </CCol> -->
              <CCol sm="3">
                <div class="form-group" style="margin-top: 30px">
                  <CButton
                      type="submit"
                      size="sm"
                      color="primary"
                      @click="applyFilter()"
                      v-c-tooltip="$lang.common.filter.button.filter"
                  >
                    {{ $lang.common.filter.button.filter }}
                  </CButton>
                  &nbsp;
                  <CButton
                      color="danger"
                      size="sm"
                      @click="resetFilter()"
                      v-c-tooltip="$lang.common.filter.button.cancel"
                  >
                    {{ $lang.common.filter.button.cancel }}
                  </CButton>
                </div>
              </CCol>
            </CRow>
          </transition>
          <CAlert color="success" closeButton :show.sync="dismissCountDownS" fade>{{ alertMessage }}</CAlert>
          <!-- <CTabs add-tab-classes="mt-1">
            <span @click="selected = 'Students'">
              <CTab active>
                <template slot="title">
                  Students
                </template>
              </CTab>
            </span>
            <span @click="selected = 'Professional'">
              <CTab>
                <template slot="title">
                  Professionals
                </template>
              </CTab>
            </span>
          </CTabs> -->
          <!-- <component :is="selected" style="margin-top: 20px" @changeSelected="getTab($event)"></component> -->
          <!-- <br></br> -->
          <v-server-table :columns="columns" :url="listUrl" :options="options" ref="myTable"
            @loaded="exports(self, 'Excel', module, 'DirectCandidates')">
            <template #firstName="data">
              {{ data.row.firstName }} {{ data.row.lastName }}
            </template>
            <template #mobileNo="data">
              {{ data.row.countryCode }} {{ data.row.mobileNo }}
            </template>
            <template #actions="data">
              <CButton color="primary" v-c-tooltip="$lang.buttons.general.crud.view" v-on:click="viewJob(data.row.id)"
                v-if="checkPermission('list-direct-candidate')">
                <i class="fas fa-eye"></i>
              </CButton>
              <CButton class="wallet-transaction-direct-candidate" color="success" v-c-tooltip="$lang.profile.payment.label.wallet" v-on:click="viewWalletTransaction(data.row.id)"
                v-if="checkPermission('list-direct-candidate')">
                <i class="fas fa-wallet"></i>
              </CButton>
            </template>
          </v-server-table>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>
<!-- <template>

  <v-server-table :columns="columns" url="/direct-candidates/list?type=professional" :options="options" ref="myTable"
    @loaded="exports(self, 'Excel', module, 'DirectCandidates')">
    <template #firstName="data">
      {{ data.row.firstName }} {{ data.row.lastName }}
    </template>
    <template #mobileNo="data">
      {{ data.row.countryCode }} {{ data.row.mobileNo }}
    </template>
    <template #actions="data">
      <CButton color="primary" v-c-tooltip="$lang.buttons.general.crud.view" v-on:click="viewJob(data.row.id)"
        v-if="checkPermission('list-direct-candidate')">
        <i class="fas fa-eye"></i>
      </CButton>
    </template>
  </v-server-table>

</template> -->
<script>
import Vue from "vue";
import VueForm from "vue-form";
import store from "/src/store/store.js";
import { DirectCandidates } from "/src/store/url.js";
import { Mixin } from "/src/mixins/index.js";
import options from "/src/validations/validations.js";
import { ServerTable } from "vue-tables-2";
import VueSweetalert2 from "vue-sweetalert2";
import VueJsonToCsv from "vue-json-to-csv";
import Avatar from "/src/components/Avatar";
import BeforeFilter from "../BeforeFilterOpen";

Vue.use(VueSweetalert2);
Vue.use(ServerTable, {}, false);
Vue.use(VueForm, options);
export default {
  name: "Professional",
  mixins: [Mixin],
  components: {
    BeforeFilter,
    VueJsonToCsv,
    Avatar,
  },
  data() {
    return {selected: "Students",
      json_data: [],
      toggleFilterValue: false,
      resource: {},
      statusOptions:[
        // {value: "1", label: "New"}
      ],
      json_label: {},
      json_title: "",
      err_msg: "",
      list: [],
      alertMessage: "test",
      showAlert: false,
      dismissCountDown: 0,
      dismissCountDownS: 0,
      self: this,
      activePage: 1,
      module: DirectCandidates,
      columns: [
        "firstName",
        "email",
        "mobileNo",
        "title",
        "address",
        "actions",
      ],
      data: [],
      options: {
        headings: {
          firstName: "First Name",
          email: "Email",
          mobileNo: "Mobile Number",
          title: "Title",
          address: "Address",
          actions: "Actions",
        },
        editableColumns: [],
        sortable: [],
      },
    };
  },
  created() {
    let self = this;
    self.dismissCountDown = 0;
    self.dismissCountDownS = 0;
    store.commit("showLoader", false);
    var filterDetail = JSON.parse(localStorage.getItem("Professional"));
    if(filterDetail && filterDetail.hasOwnProperty('startDate')) {
      self.resource.startDate = filterDetail.startDate;
      self.resource.endDate = filterDetail.endDate;
      // var val = "";
      // if(filterDetail.status == "Available") {
      //   val = "1";
      // }
      // if(filterDetail.status == "Occupied") {
      //   val = "2";
      // }
      // if(filterDetail.status == "New") {
      //   val = "1";
      // }
      // if(val != "") {
      //   self.resource.status = {value: val, label: filterDetail.status};
      // }
      // self.applyFilter();
      self.listUrl = "/direct-candidates/list?type=professional&fromDate="+filterDetail.startDate+"&toDate="+filterDetail.endDate;
      localStorage.setItem("Professional",null);
    } else {
      self.listUrl = "/direct-candidates/list?type=professional";
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (route.query && route.query.page) {
          this.activePage = Number(route.query.page);
        }
      },
    },
  },
  methods: {
    viewJob(id) {
      this.$router.push({ path: `direct-candidates/view/${id}` });
    },
    pageChange(val) {
      this.$router.push({ query: { page: val } });
    },
    switchFilter(show) {
      this.toggleFilterValue = show;
    },
    applyFilter() {
      let status = "";
      if (this.resource.status != null) {
        status = this.resource.status.value;
      }
      const reqObj = {
        status: status,
        fromDate: this.resource.startDate,
        toDate: this.resource.endDate,
      };
      store.commit("showLoader", true); // Loader Start
      this.listUrl = "/direct-candidates/list?type=professional";
      this.$refs.myTable.customQueries = reqObj;
      this.$refs.myTable.refresh();
    },
    resetFilter() {
      this.resource.endDate = "";
      this.resource.startDate = "";
      this.resource.status = "";
      store.commit("showLoader", true);
      this.listUrl = "/direct-candidates/list?type=professional";
      this.$refs.myTable.customQueries = {};
      this.$refs.myTable.refresh();
    },
  },
};
</script>
